import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import  { useState } from "react";
import {  faPlus, faXmark } from '@fortawesome/free-solid-svg-icons';
import { Button,  Modal, Spinner } from 'react-bootstrap';
import RegisterTextbox from '../../components/RegisterTextBox';
import TableComponent from '../../components/TableComponent';
import API from '../../api/axiosConfig';
import { useParams } from 'react-router';
import RegisterSelect from '../../components/RegisterSelect';
import CustomButton from '../../components/CustomButton';

function ProjectPhases() {
    const columns = [
        { name: "الاسم", key: "name" },
        { name: " بداية المرحلة", key: "start_date" },
        { name: "نهاية المرحلة", key: "end_date" },
        { name: "الأولوية", key: "priority_string" },
        { name: "الميزانية", key: "budget" },
        { name: "الحالة", key: "status_string" },
        { name: "", key: "actions" },
    ];
    const [rows, setRows] = useState([])
    const [error, setError] = useState([])
    const [name, setName] = useState('')
    const [startdate, setStartdate] = useState(Date.now())
    const [enddate, setEnddate] = useState(Date.now())
    const [priority, setPriority] = useState('')
    const [budget, setBudget] = useState('')
    const [status, setStatus] = useState('')
    const [showModal, setShowModal] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [tableReloadKey, setTableReloadKey] = useState(Date.now());
    const [description, setDescription] = useState('');
    const { id } = useParams();
    const [phaseid, setphaseId] = useState(null);
    const [performancesummary, setPerformancesummary] = useState('');
    const [remainingwork, setRemainingwork] = useState('');

    const handleCompletePhase = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        const formData = new FormData();
        formData.append('performance_summary', performancesummary);
        formData.append('remaining_work', remainingwork);
        formData.append('phase_id', phaseid);
        formData.append('project_id', id);

        try {
            const res = await API.post(`/projectprogress/phase/complete`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            const data = await res;
            if (data.status === 200) {
                setPerformancesummary('');
                setRemainingwork('');
                setError([]);

                setShowModal2(false);
                setIsSubmitting(false);
                setRows(data.data);
                setTableReloadKey(Date.now());
            }
        } catch (error) {
            console.error(error);
            setIsSubmitting(false);
            setError(error.response?.data?.errors || {});
        }
    };


    
    const handlePhase = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        const formData = new FormData();
        formData.append('name', name);
        formData.append('startdate', startdate);
        formData.append('enddate', enddate);
        formData.append('priority', priority);
        formData.append('budget', budget);
        formData.append('status', status);
        formData.append('description', description);
        formData.append('project_id', id);

        try {
            const res = await API.post(`/projectphase/store`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            const data = await res;
            if (data.status === 200) {
                setName('');
                setStartdate('');
                setEnddate('');
                setPriority('');
                setBudget('');
                setStatus('');
                setError([]);

                setShowModal(false);
                setIsSubmitting(false);
                setRows(data.data);
                setTableReloadKey(Date.now());
            }
        } catch (error) {
            console.error(error);
            setIsSubmitting(false);
            setError(error.response?.data?.errors || {});
        }
    };

    const dropdownOptions = [
        
        { label: "اكتمال المرحلة", action: (id , record) => {
            if(record.status === 3 ){
                alert("لا يمكن تعديل مشروع ملغي");
            }else if(record.status === 2){
                alert("المرحلة مكتملة بالفعل");
            }else{
                setShowModal2(true);
                setphaseId(id);
            }
        } },
        
        { label: "الغاء", visibleIf: (record) => record.status !== 3 && record.status !== 2, action : (id ,record) => {
      const cancelProject = async () => {
        try {
          const response = await API.get(`/projectphase/${record.id}/status/cancel`);
          if (response.status === 200) {
            setTableReloadKey(Date.now());
          }
        } catch (error) {
          console.log(error);
        }
      };
      cancelProject();
    } },
    { label: "تفعيل", visibleIf: (record) => record.status === 3, action : (id ,record) => {
      const activateProject = async () => {
        try {
          const response = await API.get(`/projectphase/${record.id}/status/activate`);
          if (response.status === 200) {
            setTableReloadKey(Date.now());
          }
        } catch (error) {
          console.log(error);
        }
      };
      activateProject();
    } },
    ];

    return (
        <>
            <div className="printcasedata-container">

                <div className="archive-report">
                    <span className="add-row-ta archiveAdd" onClick={() => setShowModal(true)}>
                        <FontAwesomeIcon icon={faPlus} /> إضافة
                    </span>
                </div>

                <TableComponent
                    apiUrl={`/projectphase/${id}`}
                    columns={columns}
                    title=" مراحل المشروع"
                    triggerReload={tableReloadKey}
                    dropdownOptions={dropdownOptions}
                />
            </div>
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                className="modal-table small-modall archModal archive-modal"
                  dialogClassName="fit-content-modal"
                
            >
                <Modal.Header>
                    <Modal.Title>إضافة مرحلة</Modal.Title>
                    <Button
                        className="custom-close-button"
                        variant="link"
                        onClick={() => setShowModal(false)}
                    >
                        <FontAwesomeIcon icon={faXmark} className="closeModal" />
                    </Button>
                </Modal.Header>
                <Modal.Body style={{marginTop:"80px"}}>
                    <RegisterTextbox label="اسم المرحلة" type="text" value={name} onChange={(e) => setName(e.target.value)} />
                    {error && error.name && <span className="error">{error.name[0]}</span>}
                    <p style={{textAlign:"right"}}> من تاريخ</p>
                    <input type="date" value={startdate} onChange={(e) => setStartdate(e.target.value)} className="custom-datepicker"/>
                    {error && error.startdate && <span className="error">{error.startdate[0]}</span>}
                    <p style={{textAlign:"right"}}> الى تاريخ</p>
                    <input type="date" value={enddate} onChange={(e) => setEnddate(e.target.value)} className="custom-datepicker"/>
                    {error && error.enddate && <span className="error">{error.enddate[0]}</span>}
                    <RegisterSelect id="priority"
                  label=" الاولوية"
                  stylee={{ width: "100%" }}
                  parentStyle={{ width: "80%" }}
                  options={[
                    { value: "", label: " اختر  الاولوية " },
                    { value: "0", label: " منخفض" },
                    { value: "1", label: " متوسط" },
                    { value: "2", label: " عالي" },
                    
                  ]}
                  name="priority"
                  value={priority}
                  onChange={(e) => setPriority(e.target.value)}
                />
                    {error && error.priority && <span className="error">{error.priority[0]}</span>}
                    <RegisterTextbox label="الميزانية" type="number" value={budget} onChange={(e) => setBudget(e.target.value)} />
                    {error && error.budget && <span className="error">{error.budget[0]}</span>}
                    <RegisterSelect id="status"
                  label=" الحالة"
                  stylee={{ width: "100%" }}
                  parentStyle={{ width: "80%" }}
                  options={[
                    { value: "", label: " اختر  الحالة " },
                    { value: "0", label: " قيد الانشاء" },
                    { value: "1", label: " فيد التنفيذ" },
                    
                  ]}
                  name="status"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                />
                    <RegisterTextbox label="الوصف" type="text" value={description} onChange={(e) => setDescription(e.target.value)} />
                    {error && error.description && <span className="error">{error.description[0]}</span>}
                   
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        إغلاق
                    </Button>
                    {
                        isSubmitting ? (
                            <Button variant="primary" disabled>
                                <Spinner animation="border" size="sm" />
                            </Button>
                        ) : (
                            <Button variant="primary" onClick={handlePhase}>
                                حفظ
                            </Button>
                        )
                    }
                </Modal.Footer>
            </Modal>
            <Modal
                show={showModal2}
                onHide={() => setShowModal2(false)}
                className="modal-table small-modall archModal archive-modal"
                  dialogClassName="fit-content-modal"
            >
                <Modal.Header>
                    <Modal.Title>إكمال المرحلة</Modal.Title>
                    <Button
                        className="custom-close-button"
                        variant="link"                        onClick={() => setShowModal2(false)}
                    >
                        <FontAwesomeIcon icon={faXmark} className="closeModal" />
                    </Button>
                </Modal.Header>
                <Modal.Body style={{marginTop:"80px"}}>
                    <RegisterTextbox label="ملخص الاداء" type="text" value={performancesummary} onChange={(e) => setPerformancesummary(e.target.value)} />
                    {error && error.description && <span className="error">{error.description[0]}</span>}
                    <RegisterTextbox label="العمل المتبقى" type="text" value={remainingwork} onChange={(e) => setRemainingwork(e.target.value)} />
                    {error && error.description && <span className="error">{error.description[0]}</span>}
                   
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal2(false)}>
                        إغلاق
                    </Button>
                    {
                        isSubmitting ? (
                            <Button variant="primary" disabled>
                                <Spinner animation="border" size="sm" />
                            </Button>
                        ) : (
                            <Button variant="primary" onClick={handleCompletePhase}>
                                حفظ
                            </Button>
                        )
                    }
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ProjectPhases;
